/** The Integrations tabs a skeleton draws, named as the feature's `IntegrationsTab`. */
export type IntegrationsSkeletonKind = 'providers' | 'tools';

/*
 * Local copies of the segments in ../../constants (a test keeps them in step): this file is in
 * the initial bundle and imports nothing of the feature.
 */
const SECTION = 'integrations';
const TOOLS = 'tools';

/**
 * Anchored at both ends, so RouteSkeleton can run it before its substring tests: a path that
 * merely holds the word `integrations`, or anything nested under a tab, never matches. No
 * lookbehind: Babel can't transpile one and Safari < 16.4 rejects the whole bundle.
 */
const INTEGRATIONS_ROUTE = new RegExp(`^/accounts/[^/]+/${SECTION}(?:/(${TOOLS}))?/?$`);

/** Which Integrations tab a path opens, as features/integrations/router.tsx declares them. */
export function integrationsSkeletonKind(pathname: string): IntegrationsSkeletonKind | null {
  const match = INTEGRATIONS_ROUTE.exec(pathname);
  if (!match) return null;
  return match[1] ? 'tools' : 'providers';
}
